export const branches = [
  {
    id: 1,
    name: "San7o Pecado Postrería - San Buenaventura",
    address: "Av. General, Calle Gral. Venustiano Carranza 20 Pte. 2972, Col. Guadalupe, San Buenaventura, 50110 San Buenaventura, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 936 2255",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.6851932!3d19.2733291!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE2JzI0LjAiTiA5OcKwNDEnMDYuNyJX!5e0!3m2!1ses!2smx!4v1234567890",
  },
  {
    id: 2,
    name: "San7o Pecado Postrería - Av Tecnológico",
    address: "Av Tecnológico 715, San Salvador Tizatlali, 52172 México, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 936 7442",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.5768247!3d19.2681464!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE2JzA1LjMiTiA5OcKwMzQnMzYuNiJX!5e0!3m2!1ses!2smx!4v1234567891",
  },
  {
    id: 3,
    name: "San7o Pecado Postrería - Providencia",
    address: "Av. Ignacio Comonfort 15, Providencia, La-colonia-, La Providencia, 52177 México, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 940 9425",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.6069063!3d19.2727122!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE2JzIxLjgiNiA5OcKwMzYnMjQuOSJX!5e0!3m2!1ses!2smx!4v1234567892",
  },
  {
    id: 4,
    name: "San7o Pecado Postrería - Los Sauces",
    address: "Eucaliptos #102 local 3, Col Los Sauces C.P. 50210, 50210 México, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 942 9700",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.5959585!3d19.351889!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDIxJzA2LjgiTiA5OcKwMzUnNDUuNSJX!5e0!3m2!1ses!2smx!4v1234567893",
  },
  {
    id: 5,
    name: "San7o Pecado Postrería - Zamarrero",
    address: "Aztecas 110, Las Culturas, 51335 San Luis Mextepec, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 944 6352",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.710726!3d19.2953602!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE3JzQzLjMiTiA5OcKwNDInMzguNiJX!5e0!3m2!1ses!2smx!4v1234567894",
  },
  {
    id: 6,
    name: "San7o Pecado Postrería - López Mateos",
    address: "Blvd. Av. Adolfo López Mateos 701 norte-Local 1, San Salvador Tizatlali, 52172 Metepec, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 944 5230",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.5888845!3d19.26959!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE2JzEwLjUiTiA5OcKwMzUnMjAuMCJX!5e0!3m2!1ses!2smx!4v1234567895",
  },
  {
    id: 7,
    name: "San7o Pecado Postrería - Ruta de la Independencia",
    address: "Calle Ruta de la Independencia 107, Independencia, 50070 Toluca de Lerdo, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 948 2672",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.6342259!3d19.3034499!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE4JzEyLjQiTiA5OcKwMzgnMDMuMiJX!5e0!3m2!1ses!2smx!4v1234567896",
  },
  {
    id: 8,
    name: "San7o Pecado Postrería - Ceboruco",
    address: "C. Ceboruco 45-local B, Xinantécatl, 52169 San Jorge Pueblo Nuevo, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 938 2190",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.6380116!3d19.260393!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE1JzM3LjQiTiA5OcKwMzgnMTYuOCJX!5e0!3m2!1ses!2smx!4v1234567897",
  },
  {
    id: 9,
    name: "San7o Pecado Postrería - Carr. Toluca - Naucalpan",
    address: "Carr. Toluca - Naucalpan 1207, San Nicolas Tolentino Otzacatipan, 50230 San Nicolás Tolentino, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 932 0433",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.5811814!3d19.3564967!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDIxJzIzLjQiTiA5OcKwMzQnNTIuMyJX!5e0!3m2!1ses!2smx!4v1234567898",
  },
  {
    id: 10,
    name: "San7o Pecado Postrería - Lázaro Cárdenas",
    address: "Calle Adolfo López Mateos 2, Lazaro Cardenas, 52148 San Salvador Tizatlalli, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 942 8153",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.5592094!3d19.2570701!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE1JzI1LjUiTiA5OcKwMzMnMzMuMiJX!5e0!3m2!1ses!2smx!4v1234567899",
  },
  {
    id: 11,
    name: "San7o Pecado Postrería - Zacango",
    address: "Carr Metepec-Zacango 830, La, 52161 Santa María Magdalena Ocotitlán, 52161 Toluca de Lerdo, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 320 7341",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.6160446!3d19.2415444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE0JzI5LjYiTiA5OcKwMzYnNTcuOCJX!5e0!3m2!1ses!2smx!4v1234567900",
  },
  {
    id: 12,
    name: "San7o Pecado Postrería - Carranza",
    address: "Venustiano Carranza 1600 LC1, Felipe Villanueva, Manuel Sotelo, Morelos 1A Sección, 50120 Toluca de Lerdo, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 941 6028",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.6652454!3d19.2799887!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE2JzQ4LjAiTiA5OcKwMzknNTQuOSJX!5e0!3m2!1ses!2smx!4v1234567901",
  },
  {
    id: 13,
    name: "San7o Pecado Postrería - Vicente Lombardo",
    address: "P.º Vicente Lombardo Toledano S/N-Local 2, Col. Barrio, La Crespa, 50228 Crespa Floresta, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 55 3787 6594",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.5992005!3d19.306672!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE4JzI0LjAiTiA5OcKwMzUnNTcuMSJX!5e0!3m2!1ses!2smx!4v1234567902",
  },
  {
    id: 14,
    name: "San7o Pecado Postrería - Avenida Lerma",
    address: "Av. Lerma 324, Santa Maria, San Isidro, 52105 San Mateo Atenco, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 955 3074",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.5540727!3d19.2717938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE2JzE4LjQiNiA5OcKwMzMnMTQuNyJX!5e0!3m2!1ses!2smx!4v1234567903",
  },
  {
    id: 15,
    name: "San7o Pecado Postrería - Pedro Ascencio",
    address: "Pedro Ascencio 300-B, Barrio San Mateo Atenco, 52140 Toluca de Lerdo, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 955 0747",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.5970096!3d19.2557085!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE1JzIwLjUiTiA5OcKwMzUnNDkuMiJX!5e0!3m2!1ses!2smx!4v1234567904",
  },
  {
    id: 16,
    name: "San7o Pecado Postrería - Santiago Tianguistenco",
    address: "16 de septiembre esquina Josefa Ortiz de Domínguez Número 1 chico, Col. Centro, 52600 Santiago Tianguistenco de Galeana, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 957 2563",
    mapUrl: "https://maps.app.goo.gl/Ys2nkrMvghQKGjW8A",
  },
  {
    id: 17,
    name: "San7o Pecado Postrería - Las Margaritas",
    address: "Avenida Ocotitlán #180, Plaza Las Margaritas, local CE-11, San Felipe Tlalmimilolpan, 52165 Toluca de Lerdo, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 956 8160",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.6352817!3d19.2517343!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE1JzA2LjIiTiA5OcKwMzgnMDcuMCJX!5e0!3m2!1ses!2smx!4v1234567906",
  },
  {
    id: 18,
    name: "San7o Pecado Postrería - Ixtlahuaca",
    address: "C. José M. Morelos 310, Col. Centro, Ixtlahuaca, 50740 Ixtlahuaca de Rayón, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 712 406 8603",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.7682488!3d19.5703477!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDM0JzEzLjMiTiA5OcKwNDYnMDUuNyJX!5e0!3m2!1ses!2smx!4v1234567907",
  },
  {
    id: 19,
    name: "San7o Pecado Postrería - Desviación Almoloya de Juárez",
    address: "Av. Almoloya de Juárez s/n-local 8, Zimbrones, 51355 San Miguel Zinacantepec, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 956 1943",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.7219481!3d19.2947013!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE3JzQwLjkiTiA5OcKwNDMnMTkuMCJX!5e0!3m2!1ses!2smx!4v1234567908",
  },
  {
    id: 20,
    name: "San7o Pecado Postrería - Calimaya",
    address: "Av. Calimaya, 56 s/n-Local d, 52220 San Andrés Ocotlán, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 317 6938",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.5829899!3d19.1851006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDExJzA2LjQiTiA5OcKwMzQnNTguOCJX!5e0!3m2!1ses!2smx!4v1234567909",
  },
  {
    id: 21,
    name: "San7o Pecado Postrería - Morelos Metepec",
    address: "Calle Jose Ma. Morelos 315-local D, San Mateo, 52140 Metepec, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 956 0707",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.608376!3d19.2556247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE1JzIwLjMiTiA5OcKwMzYnMzAuMiJX!5e0!3m2!1ses!2smx!4v1234567910",
  },
  {
    id: 22,
    name: "San7o Pecado Postrería - Valle Don Camilo",
    address: "Calle Prol. 5 de Mayo 2 Ote. 1113, Col. San Francisco, Coaxusco, 50150 Toluca de Lerdo, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 932 9724",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.6333032!3d19.2739697!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE2JzI2LjMiTiA5OcKwMzgnMDAuMyJX!5e0!3m2!1ses!2smx!4v1234567911",
  },
  {
    id: 23,
    name: "San7o Pecado Postrería - Amomolulco",
    address: "Av. Independencia 16-local C, 52005 Amomolulco, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 563 7602",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.4906257!3d19.2853024!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE3JzA3LjEiTiA5OcKwMjknMjYuMyJX!5e0!3m2!1ses!2smx!4v1234567912",
  },
  {
    id: 24,
    name: "San7o Pecado Postrería - Encinos",
    address: "C. Miguel Hidalgo 16 pte E. Zapata y 5 de Mayo Col Juarez los Chirinos, 52040 San Miguel Ameyalco, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 55 8983 7691",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.466774!3d19.285386!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE3JzA3LjQiTiA5OcKwMjgnMDAuNCJX!5e0!3m2!1ses!2smx!4v1234567913",
  },
  {
    id: 25,
    name: "San7o Pecado Postrería - Sauces III",
    address: "P.º Quetzales Manzana 7 L22, Conj U Los Sauces ÌII, Los Sauces lll, 50210 Sauces, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 925 0602",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.5918493!3d19.3592918!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDIxJzMzLjQiNiA5OcKwMzUnMzAuNyJX!5e0!3m2!1ses!2smx!4v1234567914",
  },
  {
    id: 26,
    name: "San7o Pecado Postrería - Niños Héroes",
    address: "C. Benito Juárez G. 40, Delegación San Mateo Oxtotitlán, 50100 Toluca de Lerdo, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 145 7052",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.6927159!3d19.2967975!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE3JzQ4LjUiTiA5OcKwNDEnMzMuOCJX!5e0!3m2!1ses!2smx!4v1234567915",
  },
  {
    id: 27,
    name: "San7o Pecado Postrería - Santa Cruz",
    address: "C. Francisco Villa 39, Delegación Santa Cruz Atzcapotzaltongo, 50210 Santa Cruz Otzacatipan, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 970 4797",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.6084484!3d19.3407215!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDIwJzI2LjYiTiA5OcKwMzYnMzAuNCJX!5e0!3m2!1ses!2smx!4v1234567916",
  },
  {
    id: 28,
    name: "San7o Pecado Postrería - Alpinismo",
    address: "Av. Alpinismo 660-local 7, Delegación San Buenaventura, 50110 San Buenaventura, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 972 3971",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.6926328!3d19.2617171!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE1JzQyLjIiNiA5OcKwNDEnMzMuNSJX!5e0!3m2!1ses!2smx!4v1234567917",
  },
  {
    id: 29,
    name: "San7o Pecado Postrería - Izcalli V",
    address: "Fracc. Izcalli C.V, C. Manuel J. Clouthier 1264-local 4, Rincon Colonial, 52176 Metepec, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 970 1137",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.5964938!3d19.269203!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE2JzA5LjEiTiA5OcKwMzUnNDcuNCJX!5e0!3m2!1ses!2smx!4v1234567918",
  },
  {
    id: 30,
    name: "San7o Pecado Postrería - Manuel Buendía",
    address: "Priv. Manuel Buendía Téllez 405-int 3, Col. El Balcon, 50010 Toluca de Lerdo, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 946 9974",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.6441815!3d19.321319!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE5JzE2LjciTiA5OcKwMzgnMzkuMSJX!5e0!3m2!1ses!2smx!4v1234567919",
  },
  {
    id: 31,
    name: "San7o Pecado Postrería - Col. Del Parque",
    address: "Calle Gral Eduardo Hernández Cházaro 702, Col del Parque, 50180 Toluca de Lerdo, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 946 7662",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.649672!3d19.2622921!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE1JzQ0LjIiNiA5OcKwMzgnNTguOCJX!5e0!3m2!1ses!2smx!4v1234567920",
  },
  {
    id: 32,
    name: "San7o Pecado Postrería - Garis San Mateo",
    address: "C. 2 de Abril 720-Local 4, San Francisco, 52104 San Mateo Atenco, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 947 1585",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.5415671!3d19.2573348!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE1JzI2LjQiNiA5OcKwMzInMjkuNiJX!5e0!3m2!1ses!2smx!4v1234567921",
  },
  {
    id: 33,
    name: "San7o Pecado Postrería - Barbabosa",
    address: "Morelos 81-810, Irma Patricia Galindo de Reza, 51356 San Miguel Zinacantepec, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 729 474 7965",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.0!2d-99.7132295!3d19.2851698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE3JzA2LjYiTiA5OcKwNDInNDcuNiJX!5e0!3m2!1ses!2smx!4v1234567922",
  },
  {
    id: 34,
    name: "San7o Pecado Postrería - Paseo de la Asunción",
    address: "P.º de la Asunción 120, San Salvador Tizatlali, 52172 Metepec, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 974 8622",
    mapUrl: "https://maps.app.goo.gl/WMu9BsKTBecN2iEaA",
  },
  {
    id: 35,
    name: "San7o Pecado Postrería - Centro Lerma",
    address: "Av. Miguel Hidalgo 78, Col. Centro, 52000 Lerma, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 728 143 1279",
    mapUrl: "https://maps.app.goo.gl/88f9bvkSa5ZDmFHSA",
  },
  {
    id: 36,
    name: "San7o Pecado Postrería - Alteza",
    address: "Blvd. Adolfo López Mateos 2500, Alteza, 52140 Metepec, Méx.",
    hours: "Lun-Sáb 8:00-21:00 | Dom 9:00-20:00",
    phone: "+52 722 947 3417",
    mapUrl: "https://maps.app.goo.gl/KHdeVetQoQwm2UkX6",
  },
];

export const faqs = [
  {
    question: "¿Hacen pasteles personalizados?",
    answer: "¡Sí! Todos nuestros pasteles pueden personalizarse en sabor, tamaño y decoración. Contáctanos con al menos 3 días de anticipación para pedidos especiales.",
  },
  {
    question: "¿Hacen entregas a domicilio?",
    answer: "¡Claro! Nos encuentras en Uber Eats y Didi Food para que pidas tus postres favoritos desde la comodidad de tu hogar. También puedes escribirnos por WhatsApp para entregas directas.",
  },
  {
    question: "¿Cuánto tiempo antes debo hacer mi pedido?",
    answer: "Para pasteles individuales y galletas, con 24 horas es suficiente. Para pasteles medianos y grandes, recomendamos 3-5 días de anticipación. Para bodas y eventos, mínimo 2 semanas.",
  },
  {
    question: "¿Tienen opciones sin azúcar?",
    answer: "Sí, contamos con una línea especial sin azúcar añadida para que puedas pecar sin remordimientos. Pregunta por disponibilidad en tu sucursal más cercana.",
  },
  {
    question: "¿Cómo encuentro la sucursal más cercana a mí?",
    answer: "En esta misma página tienes un mapa interactivo con todas nuestras 35 sucursales. Presiona el botón 'Ubicarme y encontrar la más cercana' para que el mapa detecte tu ubicación y te muestre la ruta directa a la sucursal más próxima.",
  },
  {
    question: "¿Cómo funciona la Fundación San7as Huellitas?",
    answer: "Un porcentaje de cada venta de productos solidarios va directamente a la fundación para cubrir gastos veterinarios, alimentación y adopción de perritos rescatados.",
  },
  {
    question: "¿Qué métodos de pago aceptan?",
    answer: "Aceptamos efectivo, tarjetas de crédito y débito (Visa, Mastercard), así como pagos por transferencia y aplicaciones móviles.",
  },
];